import { Link, useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";
import Button from "@/components/Button";
import { Eyebrow, Headline } from "@/components/Editorial";
import ProgressBar from "@/components/ProgressBar";
import { useAuth } from "@/lib/auth";
import { useCapture } from "@/lib/capture";
import { titleCase } from "@/lib/format";
import { C } from "@/lib/brand";

export default function Welcome() {
  const navigate = useNavigate();
  const { consumer } = useAuth();
  const { data: capData } = useCapture();
  const firstName = titleCase(consumer?.firstName || capData.firstName || "friend");
  const earnedDiscount = capData.smsOptIn || consumer?.welcomeDiscountEligible;

  return (
    <div data-testid="welcome-page" style={{ minHeight: "100vh", background: C.ink, color: C.cream }}>
      <header style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 24px" }}>
        <Link to="/"><Logo light size={22} /></Link>
        <span data-testid="verified-badge" style={{ padding: "6px 12px", background: C.peach, color: C.ink, fontSize: 10, fontWeight: 800, letterSpacing: "0.18em" }}>VERIFIED MEMBER</span>
      </header>

      <ProgressBar current={3} total={3} />

      <div style={{ maxWidth: 540, margin: "0 auto", padding: "56px 24px 96px", textAlign: "center" }}>
        <div data-testid="success-mark" style={{ width: 88, height: 88, borderRadius: "50%", background: C.sage, color: C.sageDark, fontSize: 40, fontWeight: 800, display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
          ✓
        </div>
        <div style={{ marginTop: 32 }}>
          <Eyebrow color={C.peach}>★ YOU'RE IN</Eyebrow>
        </div>
        <h1 style={{ marginTop: 24, fontSize: "clamp(48px, 9vw, 76px)", fontWeight: 800, letterSpacing: "-0.04em", lineHeight: 0.95, color: C.cream, textTransform: "uppercase" }}>
          WELCOME,<br />
          <span style={{ fontFamily: '"Instrument Serif", serif', fontStyle: "italic", fontWeight: 400, textTransform: "none", color: C.peach }}>{firstName}.</span>
        </h1>
        <p style={{ marginTop: 24, fontSize: 16, color: "rgba(250,246,240,0.75)", lineHeight: 1.55 }}>
          You've got full access to VOYA9. Browse programs, take an assessment, get matched with a physician.
        </p>

        {earnedDiscount && (
          <div data-testid="welcome-discount-card" style={{ marginTop: 36, padding: "28px 24px", background: C.peach, color: C.peachDark, textAlign: "left" }}>
            <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: "0.2em" }}>YOUR DISCOUNT</div>
            <div style={{ marginTop: 6, display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
              <div style={{ fontSize: 36, fontWeight: 800, letterSpacing: "-0.04em" }}>20% OFF</div>
              <div style={{ fontFamily: 'JetBrains Mono, monospace', fontWeight: 700, fontSize: 15, padding: "6px 10px", background: C.peachDark, color: C.peach }}>
                WELCOME20
              </div>
            </div>
            <div style={{ marginTop: 8, fontSize: 13, opacity: 0.85 }}>Auto-applied on your first month</div>
          </div>
        )}

        <div style={{ marginTop: 36 }}>
          <Button variant="peach" size="lg" block testId="welcome-explore-btn" onClick={() => navigate("/app")}>
            EXPLORE PROGRAMS →
          </Button>
        </div>
        <div style={{ marginTop: 16, fontSize: 12, color: "rgba(250,246,240,0.5)" }}>
          You can sign in anytime from voya9.com
        </div>
      </div>
    </div>
  );
}
